import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router'

import UserAvatarContainer from 'src/components/common/UserAvatarContainer'
import SvgIcon from 'src/components/common/SvgIcon'
// import GroupIcon from 'src/assets/icons/group.svg'
import ChatIcon from 'src/assets/icons/chat.svg'
import iosIcon from 'src/assets/icons/logo.svg'
import pollListIcon from 'src/assets/icons/poll-list-icon.png'
import pollListThemeIcon from 'src/assets/icons/poll-list-icon-theme.png'
import EventIcon from 'assets/icons/balloon-icon-gary.png'
import EventThemeIcon from 'assets/icons/balloon-icon.png'
import BetaIcon from 'assets/icons/beta-icon.png'
import { parseEventUrl } from 'src/services/url_helpers'

import { eventTokenSelector } from 'src/selectors'

import styles from 'src/components/menu/menu.scss'
export class MenuBar extends React.Component {
  render() {
    const { user, onMenuItemClick } = this.props
    const { destinationType } = parseEventUrl(location.pathname)

    return (
      <div className={styles['menu-bar']}>
        <div className={styles['logo-center']}>
          <div>
            <a href={process.env.API_APP_URL}>
              <SvgIcon icon={iosIcon} className={styles['logo']} />
            </a>
          </div>
        </div>
        {/* <div className={styles['menu-bar-item']}>
          <SvgIcon icon={GroupIcon} className={styles['icon']} padding='10px' onClick={() => onMenuItemClick('groups')} />
        </div> */}
        {user && (
          <Link to="/tp/timePoll">
            <div className={styles['menu-bar-item']}>
              <img
                src={destinationType === 'tp' ? pollListThemeIcon : pollListIcon}
                className={styles['icon']}
              />
            </div>
          </Link>
        )}
        {user && (
          <Link to="/e/list">
            <div className={styles['menu-bar-item']}>
              <img
                src={destinationType === 'e' ? EventThemeIcon : EventIcon}
                className={styles['icon']}
              />
              <img src={BetaIcon} className={styles['beta-icon']} width="25" alt="" />
            </div>
          </Link>
        )}
        <div className={styles['menu-bar-item']}>
          <SvgIcon
            icon={ChatIcon}
            className={styles['icon']}
            padding="10px"
            onClick={() => onMenuItemClick('chat')}
          />
        </div>
        <div
          className={styles['menu-bar-item']}
          onClick={() => onMenuItemClick(user ? 'profile' : 'login')}
        >
          <UserAvatarContainer user={user || {}} size={34} />
        </div>
      </div>
    )
  }
}

MenuBar.propTypes = {
  user: PropTypes.object,
  onMenuItemClick: PropTypes.func
}

function mapStateToProps(state) {
  return {
    eventToken: eventTokenSelector(state)
  }
}

export default connect(mapStateToProps)(MenuBar)



// WEBPACK FOOTER //
// ./src/components/menu/MenuBar.jsx